module.exports = __webpack_public_path__ + "img/1.6d75f6a2.jpg";